export default {
  locales: ['en', 'fr'],

  port: parseInt(process.env.PORT, 10) || 3010,

  redisPort: 6379,
  redisEndpoint: 'frankly-platform.ahuod3.ng.0001.use1.cache.amazonaws.com',

  privateRepo: {
    registry: 'http://npm.franklyinc.com:80/',
    username: 'frankly',
    password: 'frankly',
    email: 'frankly@franklyinc.com',
    defaultPackage: 'wnow'
  },

  // Set this to simulate specific affiliate site. This is usually used locally
  // in a development environment. e.g., kdrv.web.franklyinc.com
  //
  // defaultConfigHost: '0.0.0.0',

  // AMS endpoint.
  //
  amsEndpoint: {
    url: 'https://managewnow.worldnow.com/config',
    headers: {
      'X-Parse-Application-Id': 'wPJuyJsloZ14Rx7rUIk1BLLlpmrVt7rHqD5w3iza'
    }
  },

  mailServer: {
    host: "10.1.10.230",
    port: 25,
    secure: false,
    connectionTimeout: 300000
  },
  newRelicEnabled: process.env.NEW_RELIC_ENABLED === 'true',
  apiEndpoint: process.env.API_ENDPOINT || 'https://platform.franklyinc.com',
  widgetApiEndpoint: process.env.WIDGET_API_ENDPOINT || 'https://api.worldnow.com/feed/v3.0/widgets',
};



// WEBPACK FOOTER //
// ./server/config/production.js